import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X, ShoppingCart, Home, CakeSlice, ChefHat, Mail } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const { cart } = useCart();
  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);

  const navItems = [
    { path: '/', label: 'Home', icon: Home },
    { path: '/productos', label: 'Productos', icon: CakeSlice },
    { path: '/servicios', label: 'Servicios', icon: ChefHat },
    { path: '/contacto', label: 'Contacto', icon: Mail }
  ];

  return (
    <nav className="bg-gradient-to-r from-[#390b60] via-[#9b1b7d] to-[#e71d73] shadow-lg sticky top-0 z-50 text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center space-x-2">
            <img src='/logo/logoGK-v2.svg' alt="Guillos Kitchen Logo" className="h-10 md:h-12 lg:h-14 w-auto drop-shadow-md shrink-0" />
          </div>
          <div className="hidden md:flex items-center space-x-2">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`group relative flex items-center gap-2 px-4 py-2 rounded-full font-medium transition-colors duration-300 ${
                    isActive ? 'text-pink-600' : 'text-white/90 hover:text-white'
                  }`}
                >
                  {isActive && (
                    <motion.span
                      layoutId="navActivePill"
                      className="absolute inset-0 bg-white rounded-full shadow-md"
                      transition={{ type: 'spring', stiffness: 400, damping: 32 }}
                    />
                  )}
                  {!isActive && (
                    <span className="absolute inset-x-3 -bottom-0.5 h-0.5 origin-center scale-x-0 bg-white/80 rounded-full transition-transform duration-300 group-hover:scale-x-100" />
                  )}
                  <item.icon className="relative z-10 w-5 h-5 transition-transform duration-300 group-hover:scale-110" />
                  <span className="relative z-10">{item.label}</span>
                </Link>
              );
            })}
            <Link
              to="/carrito"
              className="flex items-center space-x-2 px-3 py-2 rounded-full bg-white/15 text-white hover:bg-white/25 transition-colors duration-300"
            >
              <ShoppingCart className="w-5 h-5" />
              {cartCount > 0 && (
                <span className="bg-red-500 text-xs rounded-full px-2 py-1">{cartCount}</span>
              )}
            </Link>
          </div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-white"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
        {isOpen && (
          <div className="md:hidden pb-4 space-y-2">
            {navItems.map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium transition-colors duration-300 ${
                    isActive
                      ? 'bg-white/15 text-white border-l-4 border-white pl-3'
                      : 'text-white/90 hover:bg-white/10'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              );
            })}
            <Link
              to="/carrito"
              className="flex items-center space-x-2 px-4 py-3 rounded-xl bg-white/15 text-white hover:bg-white/25 transition-colors duration-300"
              onClick={() => setIsOpen(false)}
            >
              <ShoppingCart className="w-5 h-5" />
              <span>Carrito ({cartCount})</span>
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
